import script from "./RecommendFormView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecommendFormView.vue?vue&type=script&lang=ts&setup=true"

import "./RecommendFormView.vue?vue&type=style&index=0&id=73c15666&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73c15666"]])

export default __exports__